import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { StripeTerminalReader, StripeTerminalReaderCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateStripeTerminalReader(): UseMutationResult<
  AxiosResponse<StripeTerminalReader>,
  AxiosError<{ message: string }>,
  StripeTerminalReaderCreate
> {
  const queryClient = useQueryClient();

  return useMutation(payload => client.post('stripe-terminal-readers/', payload), {
    onSuccess: () => {
      queryClient.invalidateQueries('gyms');
    },
  });
}
